export class AlarmsFilterModel {
}
